/* Warenkorb- und Staffel-Logik fuer den Klarkaella-Shop.
 *
 * Ersetzt das Skript, das im Vorbild die Bundle-App mit dem Warenkorb
 * verbunden hat. Gleiches Verhalten, aber gegen echte Shopify-Varianten:
 * jede Staffel ist eine eigene Variante, das Geschenk eine zweite Zeile
 * zu 0 EUR.
 */
(function () {
  'use strict';

  var SECTION = 'vg-cart';
  var busy = false;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().catch(function () { return {}; });
    });
  }

  // --------------------------------------------------------- Drawer ------
  function drawerInner() {
    return document.querySelector('.cart-drawer__inner');
  }

  function applySection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.cart-drawer__inner');
    var live = drawerInner();
    if (!fresh || !live) return;
    live.replaceChildren.apply(live, Array.prototype.slice.call(fresh.childNodes));

    // Leerer Warenkorb: Dialog bekommt im Vorbild eine eigene Klasse.
    var wrap = doc.querySelector('.vg-cart-section');
    var dialog = document.querySelector('.cart-drawer__dialog');
    if (wrap && dialog) {
      var empty = wrap.getAttribute('data-empty') === '1';
      dialog.classList.toggle('cart-drawer--empty', empty);
      dialog.setAttribute('aria-labelledby', empty ? 'cart-drawer-heading-empty' : 'cart-drawer-heading');
      var count = wrap.getAttribute('data-item-count') || '0';
      document.querySelectorAll('[data-testid="cart-bubble"]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('hidden', empty);
        var bubble = el.closest('.cart-bubble');
        if (bubble) bubble.classList.toggle('visually-hidden', empty);
      });
    }
  }

  function refresh() {
    return post('/cart/update.js', { updates: {}, sections: SECTION }).then(function (j) {
      applySection(j && j.sections && j.sections[SECTION]);
    });
  }

  function openDrawer() {
    var dialog = document.querySelector('.cart-drawer__dialog');
    var comp = dialog && dialog.closest('cart-drawer-component');
    if (comp && typeof comp.open === 'function') {
      try { comp.open(); return; } catch (e) { /* faellt unten durch */ }
    }
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) trigger.click();
  }

  // ---------------------------------------------------- Staffel/PDP ------
  function bars() {
    return Array.prototype.slice.call(document.querySelectorAll('.kaching-bundles__bar[data-vg-variant]'));
  }

  function selectedBar() {
    return document.querySelector('.kaching-bundles__bar--selected[data-vg-variant]') || bars()[0];
  }

  function syncCta() {
    var bar = selectedBar();
    if (!bar) return;
    var priceEl = document.querySelector('[data-vg-pdp-price]');
    if (priceEl) priceEl.textContent = bar.getAttribute('data-vg-price') || '';
    var cmp = document.querySelector('[data-vg-pdp-compare]');
    if (cmp) cmp.hidden = true;
  }

  function giftQtyFor(bottles) {
    return bottles >= 3 ? 2 : 1;
  }

  function giftVariantId() {
    var el = document.querySelector('[data-vg-gift-variant]');
    return el ? el.getAttribute('data-vg-gift-variant') : null;
  }

  document.addEventListener('click', function (e) {
    var bar = e.target.closest && e.target.closest('.kaching-bundles__bar[data-vg-variant]');
    if (!bar) return;
    bars().forEach(function (b) {
      b.classList.toggle('kaching-bundles__bar--selected', b === bar);
      var radio = b.querySelector('input[type="radio"]');
      if (radio) radio.checked = b === bar;
    });
    syncCta();
  }, true);

  document.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('[data-vg-pdp-go]');
    if (!go || busy) return;
    e.preventDefault();
    e.stopPropagation();
    var bar = selectedBar();
    if (!bar) return;
    busy = true;
    go.classList.add('vg-pdp-busy');
    var bottles = parseInt(bar.getAttribute('data-vg-bottles'), 10) || 1;
    var items = [];
    var gift = giftVariantId();
    if (gift) items.push({ id: Number(gift), quantity: giftQtyFor(bottles) });
    items.push({ id: Number(bar.getAttribute('data-vg-variant')), quantity: 1 });
    post('/cart/add.js', { items: items })
      .then(refresh)
      .then(openDrawer)
      .catch(function (err) { console.warn('[klarkalla]', err); })
      .then(function () { busy = false; go.classList.remove('vg-pdp-busy'); });
  }, true);

  // ------------------------------------------------ Warenkorb: Staffel ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.vg-kb-minus, .vg-kb-plus, .vg-kb-remove');
    if (!btn || busy) return;
    var td = btn.closest('td[data-vg-kb-main]');
    if (!td) return;
    e.preventDefault();
    e.stopPropagation();

    var cur = parseInt(td.getAttribute('data-qty'), 10) || 1;
    var target = btn.classList.contains('vg-kb-plus') ? cur + 1
      : btn.classList.contains('vg-kb-minus') ? cur - 1 : 0;
    var tiers = (td.getAttribute('data-tiers') || '').split(',').filter(Boolean);
    if (target > tiers.length) return;

    busy = true;
    td.closest('tr').classList.add('vg-kb-busy');

    // Alte Hauptzeile und alle Geschenkzeilen leeren, dann neu aufbauen --
    // so macht es auch das Vorbild, weil sich mit der Staffel das Geschenk
    // aendert.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftId = td.getAttribute('data-gift');
        var updates = {};
        cart.items.forEach(function (line) {
          var vid = String(line.variant_id);
          if (line.key === td.getAttribute('data-key') || vid === giftId) updates[line.key] = 0;
        });
        return post('/cart/update.js', { updates: updates });
      })
      .then(function () {
        if (target <= 0) return null;
        var items = [];
        if (td.getAttribute('data-gift')) {
          items.push({ id: Number(td.getAttribute('data-gift')), quantity: giftQtyFor(target) });
        }
        items.push({ id: Number(tiers[target - 1]), quantity: 1 });
        return post('/cart/add.js', { items: items });
      })
      .then(refresh)
      .catch(function (err) { console.warn('[klarkalla]', err); })
      .then(function () { busy = false; });
  }, true);

  // ------------------------------------------ Warenkorb: normale Zeile ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.vg-stk-minus, .vg-stk-plus, .vg-stk-remove');
    if (!btn || busy) return;
    var td = btn.closest('td[data-vg-stk]');
    if (!td) return;
    e.preventDefault();
    e.stopPropagation();
    var cur = parseInt(td.getAttribute('data-qty'), 10) || 1;
    var target = btn.classList.contains('vg-stk-plus') ? cur + 1
      : btn.classList.contains('vg-stk-minus') ? cur - 1 : 0;
    busy = true;
    post('/cart/change.js', { id: td.getAttribute('data-key'), quantity: Math.max(0, target) })
      .then(refresh)
      .catch(function (err) { console.warn('[klarkalla]', err); })
      .then(function () { busy = false; });
  }, true);

  // ------------------------------------------------------------ Upsell ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vg-upsell-add]');
    if (!btn || busy) return;
    e.preventDefault();
    e.stopPropagation();
    busy = true;
    btn.classList.add('vg-upsell-busy');
    var vid = Number(btn.getAttribute('data-vg-upsell-add'));
    post('/cart/add.js', { items: [{ id: vid, quantity: 1 }] })
      .then(function () {
        btn.classList.remove('vg-upsell-busy');
        btn.style.width = btn.offsetWidth + 'px';
        btn.classList.add('vg-upsell-added');
        btn.innerHTML = '<svg class="vg-upsell__check-pop" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>';
        return new Promise(function (r) { setTimeout(r, 750); });
      })
      .then(function () {
        var box = btn.closest('.vg-upsell');
        if (!box) return null;
        var h = box.offsetHeight;
        box.style.overflow = 'hidden';
        return box.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 320, easing: 'ease' }).finished.catch(function () {});
      })
      .then(refresh)
      .catch(function (err) { console.warn('[klarkalla]', err); })
      .then(function () { busy = false; });
  }, true);

  // ------------------------------------------- Startseiten-Kaufbutton ----
  // Der Theme-eigene Button auf der Startseite kennt die Staffel nicht.
  // Er fuehrt deshalb auf die Produktseite, wo das Set gewaehlt wird --
  // genauso wie der "KÖP NU"-Button im Kopfbereich.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button.add-to-cart-button');
    if (!btn || btn.hasAttribute('data-vg-pdp-go')) return;
    if (document.querySelector('[data-vg-pdp-go]')) return; // auf der Produktseite nichts tun
    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/products/rizinusoel-detox-wickel';
  }, true);

  // ------------------------------------------------------------ Start ----
  function init() {
    syncCta();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
